module.exports = __webpack_public_path__ + "img/corp-features-reports.ac103e37.svg";